function initSvgMap() {

	const map = document.querySelector('svg.ukmap');
	if(!map) return;
	
	const countries = map.querySelectorAll('path');
	countries.forEach(country=>{
		country.style.cursor = 'pointer';
		country.addEventListener('click', ()=>{
			let url = null;
			if(country.id === 'EN') url = '/england';
			else if(country.id === 'SC') url = '/scotland';
			else if(country.id === 'WA') url = '/wales';
			else if(country.id === 'NI') url = '/northern-ireland';
			if(url) window.location = url;
		});
	});

}
initSvgMap();

  